import { Query } from '@testing-library/dom';
import DataStoreMock from './base/data-store';
import FormStoreMock from './base/form-store';

import { GroupSummary, GroupItem, CreateGroupItem, GroupType } from 'src/stores/groups-store';
import { GroupSummaryMockData } from '../data-sources/group-summary';
import { GroupItemMockData } from '../data-sources/group-item';

export class GroupSummaryStoreMock extends DataStoreMock<GroupSummary> {
  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      errorMessage: undefined,
      items: GroupSummaryMockData,
      count: GroupSummaryMockData.length,
    });
    return true;
  }

  public async loadWithTypes(_query: Partial<Query>, groupTypes: GroupType[]) {
    this._state.set({
      isBusy: false,
      errorMessage: undefined,
      items: GroupSummaryMockData,
      count: GroupSummaryMockData.length,
    });
    return true;
  }

  public async getGroups(_query: Partial<Query>, groupTypes: GroupType[]) {
    return GroupSummaryMockData;
  }
}

export class GroupItemStoreMock extends FormStoreMock<GroupItem, CreateGroupItem> {
  public async load(id: string) {
    this._state.set({
      isBusy: false,
      item: GroupItemMockData,
    });
    return GroupItemMockData as any;
  }

  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/groups`);
  }

  groupMembersBasePath = 'users';

  public async addGroupMembers(id: string, usersIdOrEmail: string[]) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async deleteGroupMembers(id: string, userIds: string[]) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async getUsersAlreadyOnGroupType(organizationId: string, groupType: GroupType, groupId?: string) {
    return [];
  }
}
